export function  blobToObj(data) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsText(data, 'utf-8');
    reader.onload = function() {
      try {
        resolve(JSON.parse(reader.result))
      } catch (error) {
        resolve({
          code: 200,
          message: '获取文件信息成功'
        })
      }
    }
  })
}

export function exportBillingExcel (data, options = {}) {
  if (!data) {//如果没有data数据就不进行操作
    return
  }
  let tempName = options.downLoadName || 'download.xlsx'
  // iconv-lite解决中文乱码
  // let iconv = require('iconv-lite')
  // iconv.skipDecodeWarning = true// 忽略警告
  // let fileName = iconv.decode(tempName, 'gbk')
  let blob = new Blob([data], { type: options.type || 'application/vnd.ms-excel' })//转换成二进制对象
  if ('download' in document.createElement('a')) { // 不是IE浏览器
    let url = window.URL.createObjectURL(blob)//二进制对象转换成url地址
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', tempName)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link) // 下载完成移除元素
    window.URL.revokeObjectURL(url) // 释放掉blob对象
    options.callback && options.callback()
  } else {
    window.navigator.msSaveBlob(blob, tempName)
    options.callback && options.callback()
  }
}